export const data =
    [{
        timeFrame: "(2003 – 2010 Window)",
        sectionId: 1,
        image: [{
            "id": 1,
            "title": "The joint venture in the moonlit night!",
            "description": "Mixed media on paper. 2 x 3 feet.",
            "status": "Sold"
        },
        {
            "id": 2,
            "title": "The fall",
            "description": "Vitreous enamel painting. 8 x 8 inches.",
            "status": "Available, price on request"
        },
        {
            "id": 3,
            "title": "The king",
            "description": "Vitreous enamel painting. 12 x 12 inches.",
            "status": "Available, price on request"
        },
        {
            "id": 4,
            "title": "Soldier 1",
            "description": "Poster colour on earthen lid (clay material). Diameter: 10 inches.\n Work for the annual art fair of Kala Bhavana (Institute of Fine Arts), Santiniketan, India.",
            "status": "Sold"
        },
        {
            "id": 5,
            "title": "Soldier 2",
            "description": "Poster colour on earthen lid (clay material). Diameter: 10 inches.\n Work for the annual art fair of Kala Bhavana (Institute of Fine Arts), Santiniketan, India.",
            "status": "Sold"
        },
        {
            "id": 6,
            "title": "Soldier 3",
            "description": "Poster colour on earthen lid (clay material). Diameter: 10 inches.\n Work for the annual art fair of Kala Bhavana (Institute of Fine Arts), Santiniketan, India.",
            "status": "Sold"
        },
        {
            "id": 7,
            "title": "Soldier 4",
            "description": "Poster colour on earthen lid (clay material). Diameter: 10 inches.\n Work for the annual art fair of Kala Bhavana (Institute of Fine Arts), Santiniketan, India.",
            "status": "Sold"
        },
        {
            "id": 8,
            "title": "Soldier 5",
            "description": "Poster colour on earthen lid (clay material). Diameter: 10 inches.\n Work for the annual art fair of Kala Bhavana (Institute of Fine Arts), Santiniketan, India.",
            "status": "Sold"
        },
        {
            "id": 9,
            "title": "The black and white affair 1",
            "description": "Pastel on paper. 3.5 x 10 feet.",
            "status": "Available, price on request"
        },
        {
            "id": 10,
            "title": "The black and white affair 2",
            "description": "Pastel on paper. 3.5 x 10 feet.",
            "status": "Available, price on request"
        },
        {
            "id": 11,
            "title": "The black and white affair 3",
            "description": "Pencil on paper. Each drawing: 8 x 10 inches.",
            "status": "Available, price on request"
        },
        {
            "id": 12,
            "title": "The black and white affair 4",
            "description": "Pencil on paper. Each drawing: 6 x 8 inches.",
            "status": "Available, price on request"
        },
        {
            "id": 13,
            "title": "Picnic in the jungle",
            "description": "Acrylic on canvas. 5 x 7 feet.",
            "status": "Sold"
        },
        {
            "id": 14,
            "title": "Mountains in springtime",
            "description": "Acrylic on canvas and paper. Canvas: 5 x 7 feet. Paper scroll: 2 x 6 feet.",
            "status": "Sold"
        },
        {
            "id": 15,
            "title": "Bananaman on my canvas",
            "description": "Acrylic on canvas. 6 x 10 feet (joint canvas).",
            "status": "Sold"
        },
        {
            "id": 16,
            "title": "The angel's wife",
            "description": "Acrylic on canvas. 6 x 10 feet (joint canvas).",
            "status": "Sold"
        },
        {
            "id": 17,
            "title": "The day dreamer",
            "description": "Acrylic on canvas. 6 x 10 feet (joint canvas).",
            "status": "Sold"
        },
        {
            "id": 18,
            "title": "Phonecall at midnight",
            "description": "Acrylic on canvas. 6 x 10 feet (joint canvas).",
            "status": "Sold"
        },
        {
            "id": 19,
            "title": "The recall",
            "description": "Acrylic on canvas. 6 x 10 feet (joint canvas).",
            "status": "Available, price on request"
        },
        {
            "id": 20,
            "title": "Waiting to bloom",
            "description": "Acrylic on canvas. 6 x 10 feet (joint canvas).",
            "status": "Available, price on request"
        }]
    },
    {
        timeFrame: "(2011 – 2018 Window)",
        sectionId: 2,
        image: [
            {
                "id": 21,
                "title": "Before the progress report",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 22,
                "title": "Shell of a snail",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 23,
                "title": "Will you put up the mosquito net for me?",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 24,
                "title": "The broken sky",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 25,
                "title": "Frida's chronic loneliness gives me a little rest",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 26,
                "title": "Looking for that old blazer",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 27,
                "title": "The stitched stole",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 28,
                "title": "The hunting season",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 29,
                "title": "That rainy birthday night",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 30,
                "title": "Chin up Princess!",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": "Sold"
            },
            {
                "id": 31,
                "title": "A few insomnia sufferers",
                "description": "Acrylic on canvas board. 14 x 18 inches.",
                "status": "Sold"
            },
            {
                "id": 32,
                "title": "Swayed by his bicycle",
                "description": "Acrylic on canvas. 2 x 3 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 33,
                "title": "The homosexual couple",
                "description": "Acrylic on canvas. 3 x 4 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 34,
                "title": "A futile race",
                "description": "Acrylic on canvas. 3 x 4 feet.",
                "status": "Sold"
            },
            {
                "id": 35,
                "title": "G stands for gardening!",
                "description": "Acrylic on canvas. 3 x 4 feet.",
                "status": "Sold"
            },
            {
                "id": 36,
                "title": "After dinner walk a mile!",
                "description": "Acrylic on canvas. 3 x 4 feet.",
                "status": "Sold"
            },
            {
                "id": 37,
                "title": "A reality show",
                "description": "Acrylic on canvas. 3 x 4 feet.",
                "status": "Sold"
            },
            {
                "id": 38,
                "title": "When the frozen night comes",
                "description": "Acrylic on canvas. 3 x 4 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 39,
                "title": "The girl left at circus",
                "description": "Acrylic on canvas. 2 x 3 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 40,
                "title": "The ideal funhouse mirror!",
                "description": "Acrylic on canvas. 2.5 x 3 feet.",
                "status": "Available, price on request"
            }]
    },
    {
        timeFrame: "(2019 – Recent Window)",
        sectionId: 3,
        image: [
            {
                "id": 41,
                "title": "The sewing lessons",
                "description": "Acrylic on canvas. 2 x 3 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 42,
                "title": "When I cloth myself in his body",
                "description": "Acrylic on canvas. 3.8 x 4.7 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 43,
                "title": "Her unwanted giant moustache!",
                "description": "Acrylic on canvas. 3.8 x 4.7 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 44,
                "title": "When the lonely peacock announced his marriage",
                "description": "Acrylic on canvas. 3.8 x 4.7 feet.",
                "status": "Sold"
            },
            {
                "id": 45,
                "title": "My parents and their daughter's marriage!",
                "description": "Acrylic on canvas. 3.8 x 4.7 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 46,
                "title": "Yours forever, Cinderella.",
                "description": "Collage on paper. 13.5 x 21 inches.",
                "status": "Available, price on request"
            },
            {
                "id": 47,
                "title": "Not even after this life",
                "description": "Collage on paper. 10 x 16.5 inches.",
                "status": "Available, price on request"
            },
            {
                "id": 48,
                "title": "The locked door",
                "description": "Collage on paper. 13.5 x 42 inches.",
                "status": "Available, price on request"
            },
            {
                "id": 49,
                "title": "Ready, aim, fire!",
                "description": "Collage on paper. 9 x 17.5 inches.",
                "status": "Available, price on request"
            },
            {
                "id": 50,
                "title": "The cloud capped star",
                "description": "Collage on paper. 6 x 16.5 inches.",
                "status": "Available, price on request"
            },
            {
                "id": 51,
                "title": "The football ground",
                "description": "Mixed media on paper. 1 x 2 feet.",
                "status": "Sold"
            },
            {
                "id": 52,
                "title": "Never ending phonecalls",
                "description": "Mixed media on paper. 1 x 2.5 feet.",
                "status": "Sold"
            },
            {
                "id": 53,
                "title": "The pillows are too heavy!",
                "description": "Mixed media on paper. 1 x 2 feet.",
                "status": "Sold"
            },
            {
                "id": 54,
                "title": "Made for each other",
                "description": "Mixed media on paper. 1 x 2 feet.",
                "status": "Sold"
            },
            {
                "id": 55,
                "title": "The green room",
                "description": "Mixed media on paper. 1.5 x 2.5 feet.",
                "status": "Sold"
            },
            {
                "id": 56,
                "title": "Smoking outside the old castle",
                "description": "Mixed media on paper. 1 x 2 feet.",
                "status": "Sold"
            },
            {
                "id": 57,
                "title": "The holes are dangerous!",
                "description": "Mixed media on paper. 1 x 2 feet.",
                "status": "Sold"
            },
            {
                "id": 58,
                "title": "Bed of roses!",
                "description": "Mixed media on paper. 1 x 2.5 feet.",
                "status": "Sold"
            },
            {
                "id": 59,
                "title": "The invisible divider",
                "description": "Mixed media on paper. 1 x 2 feet.",
                "status": "Sold"
            },
            {
                "id": 60,
                "title": "An urban dense forest",
                "description": "Mixed media on paper. 1 x 2.5 feet.",
                "status": "Sold"
            },
            {
                "id": 61,
                "title": "He doesn’t smoke!",
                "description": "Mixed media on paper. 1.5 x 1.5 feet.",
                "status": "Sold"
            },
            {
                "id": 62,
                "title": "The giant escort!",
                "description": "Mixed media on paper. 1 x 2 feet.",
                "status": "Sold"
            },
            {
                "id": 63,
                "title": "The living room",
                "description": "Mixed media - wood, canvas board, insulation foam, cloth, paper, iron, fiber.",
                "status": "Available, price on request"
            },
            {
                "id": 64,
                "title": "The living room, detail",
                "description": "Acrylic on canvas board. 12 x 12 inches.",
                "status": ""
            },
            {
                "id": 65,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 66,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 67,
                "title": "The living room, detail",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": ""
            },
            {
                "id": 68,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 69,
                "title": "The living room, detail",
                "description": "Acrylic on canvas board. 12 x 12 inches.",
                "status": ""
            },
            {
                "id": 70,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 71,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 72,
                "title": "The living room, detail",
                "description": "Acrylic on canvas board. 10 x 12 inches.",
                "status": ""
            },
            {
                "id": 73,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 74,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 75,
                "title": "The living room, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 76,
                "title": "The living room",
                "description": "Photograph from a different angle",
                "status": ""
            },
            {
                "id": 77,
                "title": "My pet 1 - mini dragonfly",
                "description": "Mixed media - insulation foam, paper, iron wire.",
                "status": "Available, price on request"
            },
            {
                "id": 78,
                "title": "My pet 2 - giant dragonfly",
                "description": "Mixed media - wood, insulation foam, wool, cotton cloth, paper, steel rod.",
                "status": "Available, price on request"
            },
            {
                "id": 79,
                "title": "My pet 2 - giant dragonfly",
                "description": "Photograph from a different angle",
                "status": ""
            },
            {
                "id": 80,
                "title": "My pet 2 - giant dragonfly, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 81,
                "title": "My pet 2 - giant dragonfly, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 82,
                "title": "My pet 2 - giant dragonfly, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 83,
                "title": "My pet 2 - giant dragonfly",
                "description": "Photograph from a different angle",
                "status": ""
            },
            {
                "id": 84,
                "title": "My pet 3 - black ducks",
                "description": "Mixed media - insulation foam and paper.",
                "status": "Available, price on request"
            },
            {
                "id": 85,
                "title": "My pet 3 - black ducks",
                "description": "Photograph from a different angle",
                "status": ""
            },
            {
                "id": 86,
                "title": "My pet 4 - the swans",
                "description": "Mixed media - wood, insulation foam, wool, paper.",
                "status": "Available, price on request"
            },
            {
                "id": 87,
                "title": "My pet 4 - the swans, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 88,
                "title": "Croak",
                "description": "Each human figure: Fiber, Each apple: Plaster of paris, Sanitary napkin: Cloth. Life size.",
                "status": "Available, price on request"
            },
            {
                "id": 89,
                "title": "Croak",
                "description": "Photograph from a different angle",
                "status": ""
            },
            {
                "id": 90,
                "title": "The lost weapons",
                "description": "Acrylic on canvas. 5 x 6 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 91,
                "title": "When the lonely peacock announced his second marriage",
                "description": "Acrylic on canvas. 5 x 6 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 92,
                "title": "The fake celebration",
                "description": "Acrylic on canvas. 5 x 6 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 93,
                "title": "The memory of his charming thorns 1",
                "description": "Acrylic on canvas. 5 x 6 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 94,
                "title": "The memory of his charming thorns 2",
                "description": "Acrylic on canvas and insulation foam. 5 x 15 feet.",
                "status": "Available, price on request"
            },
            {
                "id": 95,
                "title": "The fancy cave",
                "description": "Mixed media - wood, canvas board, cloth, insulation foam, wool, paper.",
                "status": "Available, price on request"
            },
            {
                "id": 96,
                "title": "The fancy cave, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 97,
                "title": "The fancy cave, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 98,
                "title": "The fancy cave, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 99,
                "title": "The fancy cave, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 100,
                "title": "The fancy cave, detail",
                "description": "",
                "status": ""
            },
            {
                "id": 101,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 102,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 103,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 104,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 105,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 106,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 107,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 108,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 109,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            },
            {
                "id": 110,
                "title": "Home",
                "description": "Acrylic on wall/ door/ furniture.",
                "status": "This kind of work can be done on request"
            }
        ]
    }
    ]




